/* * @描述: 工单列表 * @版本: 1.0 * @作者: 冯强 * @创建时间: 2025-02-19 11:07:52 */
<template>
    <div class="page_container">
        <div class="work_order_list_wrap">
            <div class="left_menu_wrap">
                <ul class="work_order_type_list">
                    <li
                        v-for="item in workOrderTypeList"
                        :class="{ active: workOrderType === item.value }"
                        class="work_order_type_item"
                        @click="handleClickWorkOrderType(item)"
                    >
                        <div class="flex_wrap">
                            <i :class="item.icon" class="iconfont"></i>
                            <span class="label" v-text="item.label"></span>
                        </div>
                        <span v-if="item.total > 0">{{ item.total > 99 ? "99+" : item.total }}</span>
                    </li>
                </ul>
                <ul class="left_menu_list">
                    <li
                        class="left_menu_item"
                        :class="{ active: statisticsType == 'statistics_report' }"
                        @click="handleClickStatistics('statistics_report')"
                    >
                        <i class="iconfont icon-zhuzhuangtu"></i>
                        <span>统计报表</span>
                    </li>
                    <li
                        class="left_menu_item"
                        :class="{ active: statisticsType == 'visual_charts' }"
                        @click="handleClickStatistics('visual_charts')"
                    >
                        <i class="iconfont icon-tubiao"></i>
                        <span>可视化图表</span>
                    </li>
                </ul>
            </div>
            <template v-if="statisticsType">
                <div class="right_list_wrap right_list_wrap_statistics">
                    <template v-if="statisticsType == 'statistics_report'">
                        <WorkOrderStatisticsReport />
                    </template>
                    <template v-if="statisticsType == 'visual_charts'">
                        <WorkOrderVisualCharts />
                    </template>
                </div>
            </template>
            <div v-else class="right_list_wrap">
                <div class="page-filter_wrap">
                    <div class="page-filter_wrap_left">
                        <el-input
                            ref="order_search_input"
                            v-model="searchForm.keyword"
                            class="filter-input"
                            clearable
                            placeholder="请输入您想搜索的内容"
                            @blur="handleClickSearch"
                            @clear="handleClickSearch"
                            @keyup.enter.native="handleClickSearch"
                        >
                            <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                        </el-input>
                        <ListAdvancedFiltering
                            v-if="formInfoList.length || systemFilterFields.length"
                            :field_form="'work_orders'"
                            :field_list="formInfoList"
                            :system_fields="systemFilterFields"
                            @sendFilterData="getFilterData"
                        />
                    </div>
                    <div class="page-filter_wrap_right">
                        <el-button type="primary" v-if="is_cereate_btn" @click="handleClickAddWorkOrder">新建工单 </el-button>
                    </div>
                </div>
                <div v-loading="loading" class="page_table_content">
                    <CustomVxeTable
                        id="workOrderTableList"
                        ref="workOrderTableList"
                        :class="{ 'custom-table': filterCount && !selectedList.length }"
                        :customConfig="tableCustomConfig"
                        :empty-render="{ name: 'NotData' }"
                        :isShowToolBar="true"
                        :pagination.sync="pagination"
                        :reduceHeight="reduceHeight"
                        :tableData="workOrderTableList"
                        @handleCurrentChange="handleCurrentChange"
                        @handleSizeChange="handleSizeChange"
                        @selection-change="selectionChange"
                    >
                        <!-- <vxe-column fixed="left" type="checkbox" width="42"></vxe-column> -->
                        <vxe-column field="workorder_num" fixed="left" title="工单编号" width="150">
                            <template #default="{ row }">
                                <div
                                    class="link-label"
                                    @click="handleClickWorkOrderDetail(row)"
                                    v-text="row.workorder_num"
                                ></div>
                            </template>
                        </vxe-column>
                        <vxe-column
                            v-for="field in formInfoList"
                            :key="field.field_key"
                            :align="field.align ? 'right' : 'left'"
                            :field="field.field_key"
                            :title="field.field_name"
                            show-overflow
                            :width="field.field_type == 'date_range_apm' ? 280 : 200"
                        >
                            <template #default="{ row }">
                                <div v-if="field.field_type === 'contact'">
                                    <div v-if="row[field.field_key].length">
                                        <div v-for="item in row[field.field_key]" class="custom_contact_field_wrap">
                                            <PersonnelCard v-if="item.id" :userId="item.id">
                                                <template slot="container">
                                                    <img
                                                        :src="item.avatar ? item.avatar : defaultImg"
                                                        alt=""
                                                        class="avatar"
                                                    />
                                                    <span class="name" v-text="item.name"></span>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'department'">
                                    <div v-if="row[field.field_key].length">
                                        <div v-for="item in row[field.field_key]">
                                            <el-tooltip :content="item.full_path" effect="dark" placement="top">
                                                <span v-text="item.department_name"></span>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'radio'">
                                    <span
                                        v-if="row[field.field_key]"
                                        :class="{ is_tag_interaction: field.extend.tag_interaction }"
                                        v-text="row[field.field_key]"
                                    ></span>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'checkbox'">
                                    <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span
                                            v-for="item in row[field.field_key]"
                                            :class="{ is_tag_interaction: field.extend.tag_interaction }"
                                            v-text="item"
                                        >
                                        </span>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'checkbox_user_tag'">
                                    <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span
                                            v-for="item in row[field.field_key]"
                                            class="is_tag_interaction"
                                            v-text="item.name"
                                        >
                                        </span>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'image'">
                                    <div v-if="row[field.field_key].length" class="table_custom_image_wrap">
                                        <el-image
                                            :preview-src-list="row[field.field_key].map((img) => img.file_path)"
                                            :src="row[field.field_key][0].file_path"
                                            fit="cover"
                                        >
                                        </el-image>
                                        <el-popover
                                            :visible-arrow="false"
                                            placement="bottom-start"
                                            popper-class="table_custom_image_popover"
                                            title=""
                                            trigger="hover"
                                            width="254"
                                        >
                                            <div slot="reference">
                                                <span
                                                    v-if="row[field.field_key].length > 1"
                                                    class="image_count"
                                                    v-text="`+${row[field.field_key].length - 1}`"
                                                ></span>
                                            </div>
                                            <ul class="image_list">
                                                <li
                                                    v-for="(img, img_index) in row[field.field_key]"
                                                    :key="img_index"
                                                    class="image_item"
                                                >
                                                    <el-image
                                                        :preview-src-list="
                                                            row[field.field_key].map((img) => img.file_path)
                                                        "
                                                        :src="img.file_path"
                                                        fit="cover"
                                                    >
                                                    </el-image>
                                                </li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'file'">
                                    <div v-if="row[field.field_key].length" class="table_custom_file_wrap">
                                        <div class="first_file_wrap">
                                            <div
                                                class="file_name_wrap"
                                                v-text="row[field.field_key][0].file_name"
                                            ></div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览" effect="dark" placement="top">
                                                    <span
                                                        class="handle_icon_wrap"
                                                        @click="handleClickPreview(row[field.field_key][0])"
                                                    >
                                                        <i class="iconfont icon-yanjing"></i>
                                                    </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="下载" effect="dark" placement="top">
                                                    <span
                                                        class="handle_icon_wrap"
                                                        @click="handleClickDownloadFile(row[field.field_key][0])"
                                                    >
                                                        <i class="iconfont icon-daochu"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'invoice'">
                                    <div v-if="row[field.field_key].length"></div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'relate_approve_form'"></div>
                                <div v-else-if="field.field_type === 'id_card'">
                                    <div v-if="row[field.field_key].value" class="custom_id_card_field_wrap">
                                        <span v-text="row[field.field_key].value"></span>
                                        <el-popover
                                            placement="bottom"
                                            popper-class="id_card_detail_popper"
                                            trigger="click"
                                            width="350"
                                        >
                                            <span slot="reference" class="handle_icon_wrap">
                                                <i class="iconfont icon-shenfenzheng"></i>
                                            </span>
                                            <el-form size="small">
                                                <el-form-item v-if="row[field.field_key].name" label="姓名" prop="name">
                                                    <span v-text="row[field.field_key].name"></span>
                                                </el-form-item>
                                                <el-form-item
                                                    v-if="row[field.field_key].birthday"
                                                    label="出生日期"
                                                    prop="birthday"
                                                >
                                                    <span v-text="row[field.field_key].birthday"></span>
                                                </el-form-item>
                                                <el-form-item
                                                    v-if="row[field.field_key].address"
                                                    label="家庭住址"
                                                    prop="name"
                                                >
                                                    <span v-text="row[field.field_key].address"></span>
                                                </el-form-item>
                                                <el-form-item label="身份证号" prop="value">
                                                    <span v-text="row[field.field_key].value"></span>
                                                </el-form-item>
                                            </el-form>
                                            <img
                                                alt=""
                                                class="ic_card_icon"
                                                src="https://download.hecoos.com/enlightv/2024-48/2d35b952fcb868047612cca8bf82a615.png"
                                            />
                                        </el-popover>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'paying_teller'">
                                    <div
                                        v-if="row[field.field_key] && row[field.field_key].text"
                                        class="custom_paying_teller_field_wrap"
                                    >
                                        <span v-text="row[field.field_key].text"></span>
                                        <el-popover
                                            placement="bottom"
                                            popper-class="paying_teller_detail_popper"
                                            trigger="click"
                                            width="350"
                                        >
                                            <span slot="reference" class="handle_icon_wrap">
                                                <i class="iconfont icon-zhanghu"></i>
                                            </span>
                                            <el-form class="custom_detail_form" label-position="top" size="small">
                                                <el-form-item label="账户类型" prop="account_type">
                                                    <span
                                                        v-text="
                                                            row[field.field_key].account_type === 1
                                                                ? '个人账户'
                                                                : '对公账户'
                                                        "
                                                    ></span>
                                                </el-form-item>
                                                <el-form-item label="户名" prop="account_name">
                                                    <span v-text="row[field.field_key].account_name"></span>
                                                </el-form-item>
                                                <el-form-item label="账号" prop="card_number">
                                                    <span v-text="row[field.field_key].card_number"></span>
                                                </el-form-item>
                                                <el-form-item label="所属银行" prop="bank_name">
                                                    <span v-text="row[field.field_key].bank_name"></span>
                                                </el-form-item>
                                                <el-form-item
                                                    v-if="field.extend.bank_branch_is_show"
                                                    label="银行支行"
                                                    prop="bank_branch"
                                                >
                                                    <span v-text="row[field.field_key].bank_branch"></span>
                                                </el-form-item>
                                            </el-form>
                                        </el-popover>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'table'"></div>
                                <div v-else-if="field.field_type === 'radio_order'">
                                    <template v-if="row.order_id.text">
                                        <span
                                            class="link-label"
                                            @click="handleClickRelateOrderDetail(row)"
                                            v-text="row.order_id.text"
                                        ></span>
                                    </template>
                                    <template v-else>
                                        <span>--</span>
                                    </template>
                                </div>
                                <div v-else-if="field.field_type === 'radio_project'">
                                    <template v-if="row.project_id.text">
                                        <span
                                            class="link-label"
                                            @click="handleClickRelateProjectDetail(row)"
                                            v-text="row.project_id.text"
                                        ></span>
                                    </template>
                                    <template v-else>
                                        <span>--</span>
                                    </template>
                                </div>
                                <div v-else-if="field.field_type === 'customer_contact'">
                                    <span v-for="item in row.contact_id" v-text="item.name"></span>
                                </div>
                                <div v-else-if="field.field_type === 'workorder_role'">
                                    <div v-if="row[field.field_key].length" style="display: flex; gap: 8px; flex-wrap: wrap">
                                        <!-- <div
                                        v-for="(item, index) in row[field.field_key]"
                                        :key="index"
                                        :style="{
                                            zIndex:
                                                activeAvatarIndex === index && activeRowId === row.id ? 999 : index,
                                        }"
                                        class="custom_contact_field_wrap work_order_contact_field_wrap user-avatar-btn"
                                        :class="{
                                            'user-avatar-btn':
                                                activeAvatarIndex === index && activeRowId === row.id,
                                        }"
                                        @mouseenter="handleMouseEnter(index, row.id)"
                                        @mouseleave="handleMouseLeave"
                                    >
                                        <userDetailPopover v-if="item.id" :uid="item.id">
                                            <div slot="container">
                                                <div class="work_user_info_wrap">
                                                    <img
                                                        :src="item.avatar ? item.avatar : defaultImg"
                                                        alt=""
                                                        class="avatar"
                                                    />
                                                    <span class="name" v-text="item.name"></span>
                                                </div>
                                            </div>
                                        </userDetailPopover>
                                    </div> -->
                                        <div
                                            v-for="(item, index) in row[field.field_key]"
                                            :key="index"
                                            class="custom_contact_field_wrap"
                                        >
                                            <PersonnelCard v-if="item.id" :userId="item.id">
                                                <template slot="container">
                                                    <img
                                                        :src="item.avatar ? item.avatar : defaultImg"
                                                        alt=""
                                                        class="avatar"
                                                    />
                                                    <span class="name" v-text="item.name"></span>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'system'"></div>
                                <span v-else v-text="row[field.field_key] ? row[field.field_key] : '--'"></span>
                            </template>
                        </vxe-column>
                        <vxe-column title="发起人" width="150">
                            <template #default="{ row }">
                                <div class="custom_contact_field_wrap">
                                    <PersonnelCard v-if="row.user.id" :userId="row.user.id">
                                        <template slot="container">
                                            <img
                                                :src="row.user.avatar ? row.user.avatar : defaultImg"
                                                alt=""
                                                class="avatar"
                                            />
                                            <span class="name" v-text="row.user.name"></span>
                                        </template>
                                    </PersonnelCard>
                                </div>
                            </template>
                        </vxe-column>
                        <template
                            v-if="
                                workOrderType == 'all' ||
                                workOrderType == 'create' ||
                                workOrderType == 'processing' ||
                                workOrderType == 'finish' ||
                                workOrderType == 'close'
                            "
                        >
                            <vxe-column title="实施人" width="200" key="processing_users">
                                <template #default="{ row }">
                                    <div
                                        v-if="row.processing_users.length"
                                        style="display: flex; gap: 8px; flex-wrap: wrap"
                                    >
                                        <div
                                            v-for="(item, index) in row.processing_users"
                                            :key="index"
                                            class="custom_contact_field_wrap"
                                        >
                                            <PersonnelCard
                                                v-if="item.processing_user && item.processing_user.id"
                                                :userId="item.processing_user.id"
                                            >
                                                <template slot="container">
                                                    <img
                                                        :src="
                                                            item.processing_user.avatar
                                                                ? item.processing_user.avatar
                                                                : defaultImg
                                                        "
                                                        alt=""
                                                        class="avatar"
                                                    />
                                                    <span class="name" v-text="item.processing_user.name"></span>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </div>
                                    <span v-else>--</span>
                                </template>
                            </vxe-column>
                        </template>
                        <vxe-column title="状态" width="120">
                            <template #default="{ row }">
                                <span class="work_order_status" :class="'work_order_status' + row.status">{{
                                    row.status_text
                                }}</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="operate" fixed="right" width="90">
                            <template #header>
                                <span>操作</span>
                                <el-tooltip class="item" content="表头设置" effect="dark" placement="bottom-start">
                                    <i
                                        class="iconfont icon-biaotoushezhi table-header-icon"
                                        @click="handleClickCustom"
                                    ></i>
                                </el-tooltip>
                            </template>
                            <!-- 工单状态：0=>审批中，1=>待指派，2=>待出发，3=>待实施，4=>实施中，5=>实施完成，6=>已结单，7=>已评价,-1=>已拒绝，-2=>已撤销，-3=>已关闭 -->
                            <!-- 实施人状态：0=>未出发，1=>待实施, 2=>实施中, 3=>实施完成 -->
                            <template #default="{ row }">
                                <div class="table-operate-icon">
                                    <el-dropdown placement="bottom-end" trigger="click" v-if="row.status !== 7">
                                        <el-tooltip content="更多" effect="dark" placement="top">
                                            <i class="iconfont el-icon-more"></i>
                                        </el-tooltip>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                v-if="(row.status == -1 || row.status == -2) && row.uid === owner_uid"
                                                @click.native="handleClickDelWorkOrder(row)"
                                                >删除
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="row.status === 0 && row.uid === owner_uid"
                                                @click.native="handleClickRevokeWorkOrder(row)"
                                                >撤销
                                            </el-dropdown-item>
                                            <!-- <el-dropdown-item
                                                v-if="
                                                    (row.status === 1 ||
                                                        row.status === 2 ||
                                                        row.status === 3 ||
                                                        row.status === 4 ||
                                                        row.status === 5) &&
                                                    row.uid === owner_uid
                                                "
                                                @click.native="handleClickEditWorkOrder(row)"
                                                >编辑信息
                                            </el-dropdown-item> -->
                                            <el-dropdown-item
                                                v-if="
                                                    (row.status === 1 ||
                                                        row.status === 2 ||
                                                        row.status === 3 ||
                                                        row.status === 4 ||
                                                        row.status === 5) &&
                                                    row.uid === owner_uid
                                                "
                                                @click.native="handleClickCloseWorkOrder(row)"
                                                >关闭工单
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="
                                                    (row.status == -1 || row.status == -2 || row.status == -3) &&
                                                    row.uid === owner_uid
                                                "
                                                @click.native="handleClickRestartWorkOrder(row)"
                                                >再次发起
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="
                                                    (row.status === 1 ||
                                                        row.status === 2 ||
                                                        row.status === 3 ||
                                                        row.status === 4 ||
                                                        row.status === 5) &&
                                                    ((row.assign_uids.length && row.assign_uids.includes(owner_uid)) || (!row.assign_uids.length && row.is_assign_user))
                                                "
                                                @click.native="handleClickDistributeWorkOrder(row)"
                                                >分配实施人员
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="
                                                    (row.status === 2 || row.status === 3 || row.status === 4) &&
                                                    ((row.assign_uids.length && row.assign_uids.includes(owner_uid)) || (!row.assign_uids.length && row.is_assign_user))
                                                "
                                                @click.native="handleClickReplaceWorkOrder(row)"
                                                >替换实施人员
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="
                                                    (row.status === 2 || row.status === 3 || row.status === 4) &&
                                                    ((row.assign_uids.length && row.assign_uids.includes(owner_uid)) || (!row.assign_uids.length && row.is_assign_user))
                                                "
                                                @click.native="handleClickRevokeDistributeWorkOrder(row)"
                                                >撤回实施人员
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="row.processing_status === 0 && row.is_processing_user && (row.status > 0 && row.status < 6)"
                                                @click.native="handleClickStartWorkOrder(row)"
                                                >出发
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="row.processing_status === 1 && row.is_processing_user && (row.status > 0 && row.status < 6)"
                                                @click.native="handleClickWorkOrderImplementStart(row)"
                                                >实施开始
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="
                                                    (row.processing_status === 0 || row.processing_status === 1) &&
                                                    workOrderSetForm &&
                                                    workOrderSetForm.is_transfer === 1 &&
                                                    row.is_processing_user && (row.status > 0 && row.status < 6)
                                                "
                                                @click.native="handleClickTransferWorkOrder(row)"
                                                >转单
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="row.processing_status === 2 && row.is_processing_user"
                                                @click.native="handleClickWorkOrderDailyWork(row)"
                                                >每日工作填写
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="row.processing_status === 2 && row.is_processing_user"
                                                @click.native="handleClickWorkOrderImplementEnd(row)"
                                                >实施结束
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="
                                                    row.processing_status === 3 &&
                                                    row.mode === 2 &&
                                                    row.is_processing_user &&
                                                    row.status < 6
                                                "
                                                @click.native="handleClickEndWorkOrder(row)"
                                                >结单
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="
                                                    (row.status === 5 &&
                                                        workOrderSetForm.is_evaluate == 1 &&
                                                        row.mode === 1 &&
                                                        ((row.assign_uids.length && row.assign_uids.includes(owner_uid)) || (!row.assign_uids.length && row.is_assign_user))) ||
                                                    (row.status === 6 &&
                                                        workOrderSetForm.is_evaluate == 1 &&
                                                        row.mode === 2 &&
                                                        ((row.assign_uids.length && row.assign_uids.includes(owner_uid)) || (!row.assign_uids.length && row.is_assign_user)))
                                                "
                                                @click.native="handleClickEvaluateWorkOrder(row)"
                                                >评价
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </template>
                        </vxe-column>
                    </CustomVxeTable>
                </div>
            </div>
            <el-image ref="preview_img" :preview-src-list="previewImgList" :src="previewImgSrc" style="display: none">
            </el-image>
        </div>
        <WorkOrderAssign
            :dialogVisible.sync="workOrderAssignDialogVisible"
            v-if="workOrderAssignDialogVisible"
            :workorder_id="workorder_id"
            :processing_users_selected="processing_users_selected"
            @refreshList="initData"
        />
        <WorkOrderTravel
            :dialogVisible.sync="workOrderTravelDialogVisible"
            v-if="workOrderTravelDialogVisible"
            :assign_id="assign_id"
            :workorder_id="workorder_id"
            :workorder_num="workorder_num"
            :travelInfo="travelInfo"
            @refreshList="initData"
        />
        <WorkOrderFeedBack
            :dialogVisible.sync="workOrderFeedBackDialogVisible"
            v-if="workOrderFeedBackDialogVisible"
            :workorder_id="workorder_id"
            @refreshList="initData"
        />
        <WorkOrderFeedBackFinish
            :dialogVisible.sync="workOrderFeedBackFinishDialogVisible"
            v-if="workOrderFeedBackFinishDialogVisible"
            :workorder_id="workorder_id"
            :workorder_num="workorder_num"
            :workorder_start_date="workorder_start_date"
            :workorder_start_time="workorder_start_time"
            @refreshList="initData"
        />
        <WorkOrderProcessingUserReplace
            :dialogVisible.sync="processingUserReplaceDialogVisible"
            v-if="processingUserReplaceDialogVisible"
            :workorder_id="workorder_id"
            :processing_users_selected="processing_users_selected"
            @refreshList="initData"
        />
        <WorkOrderProcessingUserRevoke
            :dialogVisible.sync="processingUserRevokeDialogVisible"
            v-if="processingUserRevokeDialogVisible"
            :workorder_id="workorder_id"
            :processing_users_selected="processing_users_selected"
            @refreshList="initData"
        />
        <WorkOrderTransfer
            :dialogVisible.sync="workOrderTransferDialogVisible"
            v-if="workOrderTransferDialogVisible"
            :workorder_id="workorder_id"
            :processing_users_selected="processing_users_selected"
            @refreshList="initData"
        />
        <WorkOrderFinish
            :dialogVisible.sync="workOrderFinishDialogVisible"
            v-if="workOrderFinishDialogVisible"
            :workorder_id="workorder_id"
            :workorder_num="workorder_num"
            :finishInfo="finishInfo"
            @refreshList="initData"
        />
        <WorkOrderEvaluate
            :dialogVisible.sync="workOrderEvaluateDialogVisible"
            v-if="workOrderEvaluateDialogVisible"
            :workorder_id="workorder_id"
            :workorder_num="workorder_num"
            :processing_users_selected="processing_users_selected"
            @refreshList="initData"
        />
    </div>
</template>
<script>
import {mapGetters, mapState} from "vuex";
import { pagination } from "@/mixins";
import ListAdvancedFiltering from "@/components/pComponents/ListAdvancedFiltering";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import WorkOrderAssign from "./work_order_assign";
import WorkOrderProcessingUserRevoke from "./work_order_processing_user_revoke";
import WorkOrderProcessingUserReplace from "./work_order_processing_user_replace";
import WorkOrderTravel from "./work_order_travel";
import WorkOrderFeedBack from "./work_order_feedback";
import WorkOrderFeedBackFinish from "./work_order_feedback_finish";
import WorkOrderFinish from "./work_order_finish";
import WorkOrderTransfer from "./work_order_transfer";
import WorkOrderEvaluate from "./work_order_evaluate";
import WorkOrderStatisticsReport from "./work_order_statistics_report";
import WorkOrderVisualCharts from "./work_order_visual_charts";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import {
    getFormFields,
    workOrderList,
    workOrderFeedbackStart,
    workOrderSetDetail,
    workOrderClose,
    workOrderDel,
    workOrderFeedbackEnd,
    workOrderNum,
    workOrderRevoke,
    roleDetail
} from "@/api";
import { tableDataFieldShow } from "@/utils";
import { getOSSData } from "@/utils/uploadOss";
import { EventBus } from "@/utils/eventBus";


export default {
    name: "WorkOrder",
    mixins: [pagination],
    data() {
        return {
            keyWord: "",
            workOrderTableList: [],
            loading: false, //加载动画
            workOrderTypeList: [
                {
                    label: "全部工单",
                    value: "all",
                    icon: "icon-gengduogongneng_weixuanzhong",
                    total: 0,
                },
                {
                    label: "我负责的工单",
                    value: "my_head",
                    icon: "icon-bumenfuzeren1",
                    total: 0,
                },
                {
                    label: "工单分配中心",
                    value: "assign",
                    icon: "icon-gongdan",
                    total: 0,
                },
                {
                    label: "我创建的工单",
                    value: "create",
                    icon: "icon-yiguanbi",
                    total: 0,
                },
                {
                    label: "进行中工单",
                    value: "processing",
                    icon: "icon-jinhangzhong",
                    total: 0,
                },
                {
                    label: "已完结工单",
                    value: "finish",
                    icon: "icon-yiwanjie",
                    total: 0,
                },
                {
                    label: "已关闭工单",
                    value: "close",
                    icon: "icon-a-yiguanbi1",
                    total: 0,
                },
            ],
            workOrderType: "all",
            statisticsType: "",
            formInfoList: [],
            systemFilterFields: [],
            searchForm: {
                keyword: "",
            },
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "workorder_num";
                },
                allowSort: true,
            },
            filterCount: 0,
            selectedList: [],
            defaultImg: require("@/assets/images/default.jpg"),
            previewImgList: [],
            previewImgSrc: "",

            workOrderAssignDialogVisible: false,
            workOrderTravelDialogVisible: false,
            workOrderFeedBackDialogVisible: false,
            workOrderFinishDialogVisible: false,
            workOrderFeedBackFinishDialogVisible: false,
            processingUserRevokeDialogVisible: false,
            processingUserReplaceDialogVisible: false,
            workOrderTransferDialogVisible: false,
            workOrderEvaluateDialogVisible: false,
            workorder_id: 0,
            workorder_num: "",
            assign_id: 0,
            old_processing_uid: 0, // 原来的实施人员
            processing_users_selected: [], // 已选择过的实施人员
            travelInfo: {}, // 工单出发其它的参数
            finishInfo: {}, // 结单其它的参数
            workorder_start_date: "", // 每个实施人员的开始时间
            workorder_start_time: "",

            // 获取工单后台配置
            workOrderSetForm: {},

            statusData: {
                0: "审批中",
                1: "待指派",
                2: "待出发",
                3: "待实施",
                4: "实施中",
                5: "实施完成",
                6: "已结单",
                7: "已评价",
                "-1": "已拒绝",
                "-2": "已撤销",
                "-3": "已关闭",
            },

            // 头像滑入当前状态
            activeAvatarIndex: 1,
            activeRowId: 48,

            is_cereate_btn: false,
        };
    },
    created() {
        this._getFromFields();
        this.getWorkOrderSetDetail();
        this.getWorkOrderNum();
        this.getRoleDetail()
        EventBus.$on("workOrderAddUpdated", this.handleClickSearch);
    },
    computed: {
        reduceHeight() {
            return this.filterCount ? 170 : 180;
        },
        ...mapState(["userInfo"]),
        owner_uid() {
            return this.userInfo && this.userInfo.user && this.userInfo.user.id;
        },
        ...mapGetters(['hasPermission']),
        hasOrderPermission() {
            return this.hasPermission('order.list', 'customer', 'Order');
        },
        hasProjectPermission() {
            return this.hasPermission('project.list', 'customer', 'Project');
        },
    },
    components: {
        ListAdvancedFiltering,
        CustomVxeTable,
        PersonnelCard,
        WorkOrderAssign,
        WorkOrderTravel,
        WorkOrderFeedBack,
        WorkOrderFinish,
        WorkOrderFeedBackFinish,
        WorkOrderProcessingUserRevoke,
        WorkOrderProcessingUserReplace,
        WorkOrderTransfer,
        WorkOrderEvaluate,
        WorkOrderStatisticsReport,
        WorkOrderVisualCharts,
        userDetailPopover,
    },
    mounted() {},
    methods: {
        //获取自定义字段列表
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "workorders",
                filter_field_type: "",
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.formInfoList = res.data;
                        this.getWorkOrderTableList();
                    } else {
                        this.$message.error(res.message);
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },

        // 获取工单后台配置
        getWorkOrderSetDetail() {
            workOrderSetDetail().then((res) => {
                this.workOrderSetForm = res.data || {};
            });
        },
        // 获取后台角色中是否配置了工单创建者，如果设置了，则只有设置的人员中可展示新增工单按钮；没有设置的话，则全部人员都可创建
        getRoleDetail() {
            roleDetail({
                role_type: "create_user"
            }).then(res=> {
                if(res.code === 200) {
                    const data = res.data || []
                    if(data && data.length) {
                        const userData = data.filter(user=> user.id == this.owner_uid)
                        this.is_cereate_btn = userData && userData.length ? true : false
                    } else {
                        this.is_cereate_btn = true;
                    }
                }
            })
        },
        initData() {
            this.getWorkOrderNum();
            this.getWorkOrderTableList();
        },
        // 获取数量
        getWorkOrderNum() {
            workOrderNum().then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    if (data) {
                        this.workOrderTypeList[1].total = data.my_head_count || 0;
                        this.workOrderTypeList[2].total = data.assign_count || 0;
                        // this.workOrderTypeList[3].total = data.create_count || 0;
                        this.workOrderTypeList[4].total = data.processing_count || 0;
                        // this.workOrderTypeList[5].total = data.finish_count || 0;
                        // this.workOrderTypeList[6].total = data.close_count || 0;
                    }
                }
            });
        },

        getWorkOrderTableList() {
            this.loading = true;
            workOrderList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                tab: this.workOrderType,
                custom_filter: this.custom_filter,
            }).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.workOrderTableList = data;
                    this.pagination.total = total;
                    tableDataFieldShow(this.formInfoList, this.workOrderTableList);
                    // if (this.workOrderType == "all") {
                    //     this.workOrderTypeList[0].total = total;
                    // }
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            });
        },

        // 搜索
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.getWorkOrderTableList();
        },

        // 搜索回车
        handleOrderKeyupEnter() {},

        //获取筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.pagination.pageNum = 1;
            this.getWorkOrderTableList();
        },

        //点击左侧工单类型
        handleClickWorkOrderType(item) {
            this.workOrderType = item.value;
            this.statisticsType = "";
            this.handleClickSearch();
        },

        // 点击左侧统计类型
        handleClickStatistics(type) {
            this.statisticsType = type;
            this.workOrderType = "";
        },

        //新建工单
        handleClickAddWorkOrder() {
            this.$router.push({
                name: "WorkOrderAdd",
                params: {
                    isPush: true,
                },
                query: {},
            });
        },

        //编辑工单
        handleClickEditWorkOrder(row) {
            this.$router.push({
                name: "WorkOrderEdit",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                    name: row.work_order_num,
                },
            });
        },

        //删除工单
        handleClickDelWorkOrder(row) {
            this.$msgbox({
                title: "删除",
                message: "确定要删除所选工单吗？",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                iconClass: "iconfont icon-yiwen",
                customClass: "icon_title_message_box icon_title_message_box_danger",
                confirmButtonClass: "el-button--danger",
                showClose: false,
            })
                .then(() => {
                    workOrderDel({ id: row.id }).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getWorkOrderNum();
                            this.getWorkOrderTableList();
                        }
                    });
                })
                .catch(() => {
                    console.log("cancel");
                });
        },

        //工单详情
        handleClickWorkOrderDetail(row) {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                    name: row.workorder_num,
                },
            });
        },

        //撤销工单
        handleClickRevokeWorkOrder(row) {
            this.$msgbox({
                title: "撤销",
                message: "确定要撤销所选工单吗？",
                confirmButtonText: "撤销",
                cancelButtonText: "取消",
                confirmButtonClass: "el-button--primary",
                iconClass: "iconfont icon-shuoming",
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                showClose: false,
            })
                .then(() => {
                    workOrderRevoke({ workorder_id: row.id, approval_id: row.approval_id }).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getWorkOrderNum();
                            this.getWorkOrderTableList();
                        }
                    });
                })
                .catch(() => {});
        },

        //关闭工单
        handleClickCloseWorkOrder(row) {
            this.$msgbox({
                title: "关闭工单",
                message: "确定要关闭所选工单吗？",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                confirmButtonClass: "el-button--primary",
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                showClose: false,
            })
                .then(() => {
                    workOrderClose({ workorder_id: row.id, workorder_num: row.workorder_num }).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getWorkOrderNum();
                            this.getWorkOrderTableList();
                        }
                    });
                })
                .catch(() => {
                    console.log("cancel");
                });
        },

        //再次发起工单
        handleClickRestartWorkOrder(row) {
            this.$router.push({
                name: "WorkOrderAddAgain",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                },
            });
        },

        //分配实施人员
        handleClickDistributeWorkOrder(row) {
            this.workorder_id = row.id;
            this.processing_users_selected = (row.processing_users || []).filter(user=> user.status !== 3);
            this.workOrderAssignDialogVisible = true;
        },

        //替换实施人员
        handleClickReplaceWorkOrder(row) {
            this.workorder_id = row.id;
            this.processing_users_selected = row.processing_users || [];
            this.processingUserReplaceDialogVisible = true;
        },

        //撤回实施人员
        handleClickRevokeDistributeWorkOrder(row) {
            this.workorder_id = row.id;
            this.processing_users_selected = row.processing_users || [];
            this.processingUserRevokeDialogVisible = true;
        },

        //工单出发
        handleClickStartWorkOrder(row) {
            if(row.processing_approval_id && row.processing_approval_status === 0) return this.$message.error("您已发起工单出发申请，请等待审批通过!")
            this.assign_id = row.assign_id || 0;
            this.workorder_id = row.id;
            this.workorder_num = row.workorder_num;
            this.travelInfo = {
                project_id: row.project_id.value,
                project_name: row.project_id.text,
                order_id: row.order_id.value,
                order_num: row.order_id.text,
            };
            this.workOrderTravelDialogVisible = true;
        },

        //工单转单
        handleClickTransferWorkOrder(row) {
            this.workorder_id = row.id;
            this.processing_users_selected = row.processing_users || [];
            this.workOrderTransferDialogVisible = true;
        },

        //工单结单
        handleClickEndWorkOrder(row) {
            const isAllFinish = row.processing_users.every((user) => user.status === 3);
            if (isAllFinish) {
                this.workorder_id = row.id;
                this.workorder_num = row.workorder_num;
                this.finishInfo = {
                    project_id: row.project_id.value,
                    project_name: row.project_id.text,
                    order_id: row.order_id.value,
                    order_num: row.order_id.text,
                };
                this.workOrderFinishDialogVisible = true;
            } else {
                this.$message.error("全部实施人实施完成后才可以结单");
            }
        },

        //工单评价
        handleClickEvaluateWorkOrder(row) {
            this.workorder_id = row.id;
            this.workorder_num = row.workorder_num;
            this.processing_users_selected = row.processing_users || [];
            this.workOrderEvaluateDialogVisible = true;
        },

        //工单每日工作填写
        handleClickWorkOrderDailyWork(row) {
            this.workorder_id = row.id;
            this.workOrderFeedBackDialogVisible = true;
        },

        //工单实施开始
        handleClickWorkOrderImplementStart(row) {
            this.$msgbox({
                title: "实施开始",
                message: "确定现在已到达现场并开始实施吗？",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                confirmButtonClass: "el-button--primary",
                iconClass: "iconfont icon-shuoming",
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                showClose: false,
            })
                .then(() => {
                    const params = {
                        workorder_id: row.id,
                        workorder_num: row.workorder_num,
                        processing_uid: this.owner_uid,
                        processing_name: this.userInfo && this.userInfo.user && this.userInfo.user.name,
                    };
                    workOrderFeedbackStart(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getWorkOrderNum();
                            this.getWorkOrderTableList();
                        }
                    });
                })
                .catch(() => {});
        },

        //工单实施结束
        handleClickWorkOrderImplementEnd(row) {
            // 1=极简模式,2=简约工程模式
            const mode = row.mode;
            if (mode === 1) {
                this.$msgbox({
                    title: "实施结束",
                    message: "确定现在已完成实施了吗？",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    confirmButtonClass: "el-button--primary",
                    iconClass: "iconfont icon-shuoming",
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                    customClass: "prompt_message_custom",
                    showClose: false,
                })
                    .then(() => {
                        workOrderFeedbackEnd({ workorder_id: row.id, workorder_num: row.workorder_num }).then((res) => {
                            if (res.code === 200) {
                                this.$message.success(res.message);
                                this.getWorkOrderNum();
                                this.getWorkOrderTableList();
                            }
                        });
                    })
                    .catch(() => {});
            } else {
                this.workorder_id = row.id;
                this.workorder_num = row.workorder_num;
                const currentUser = row.processing_users.filter(user=> user.processing_uid === this.owner_uid && user.status !== 3)[0]
                console.log(currentUser)
                this.workorder_start_date = currentUser.start_date;
                this.workorder_start_time = currentUser.start_time;
                this.workOrderFeedBackFinishDialogVisible = true;
            }
        },

        // 表头配置
        handleClickCustom() {
            this.$refs.workOrderTableList.handleOpenCustomShow();
        },

        // 列表选择事件
        selectionChange(ids) {
            this.selectedList = ids.map((item) => item.id);
        },

        // 关联订单详情
        handleClickRelateOrderDetail(row) {
            if((row.is_processing_user && this.workOrderSetForm.is_share === 1) || this.hasOrderPermission) {
                this.$router.push({
                    name: "OrderDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        order_id: row.order_id.value,
                        name: row.order_id.text,
                    },
                });
            } else {
                this.$message.error("您没有权限查看订单详情，如需查看请联系公司管理员")
            }
        },

        //点击查看关联商机详情
        handleClickRelateProjectDetail(row) {
            if((row.is_processing_user && this.workOrderSetForm.is_share === 1) || this.hasProjectPermission) {
                this.$router.push({
                    name: "BusinessDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        project_id: row.project_id.value,
                        name: row.project_id.text,
                    },
                });
            } else {
                this.$message.error("您没有权限查看商机详情，如需查看请联系公司管理员")
            }
        },

        handleSizeChange(val) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = val.pageSize;
            this.getWorkOrderTableList();
        },

        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getWorkOrderTableList();
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件类型不支持预览");
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        handleMouseEnter(index, id) {
            this.activeAvatarIndex = index;
            this.activeRowId = id;
        },
        handleMouseLeave() {
            this.activeAvatarIndex = -1;
            this.activeRowId = -1;
        },
    },
    beforeDestroy() {
        EventBus.$off("workOrderAddUpdated", this.handleClickSearch);
    },
};
</script>
<style lang="scss" scoped>
.work_order_list_wrap {
    width: 100%;
    height: 100%;
    display: flex;

    .left_menu_wrap {
        width: 195px;
        height: 100%;
        border-right: 1px solid #e8e8e8;
        background-color: #ffffff;
        padding: 12px 8px;

        .work_order_type_list {
            padding-bottom: 8px;
            border-bottom: 1px solid #e8e8e8;

            .work_order_type_item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 8px;
                border-radius: 6px;
                cursor: pointer;
                color: rgba(102, 102, 102, 100);
                .flex_wrap {
                    gap: 8px;
                }

                &:hover {
                    background: rgba(0, 0, 0, 0.04);
                    color: rgba(51, 51, 51, 1);
                }

                &.active {
                    background: rgba(41, 144, 255, 0.16);
                    border-radius: 4px;
                    font-weight: 700;
                    color: #2990ff;
                }
            }
        }

        .left_menu_list {
            padding-top: 8px;

            .left_menu_item {
                padding: 8px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 8px;
                color: rgba(102, 102, 102, 100);
                border-radius: 4px;
                &:hover {
                    background: rgba(0, 0, 0, 0.04);
                    color: rgba(51, 51, 51, 1);
                }
                &.active {
                    background: rgba(41, 144, 255, 0.16);
                    font-weight: 700;
                    color: #2990ff;
                }
            }
        }
    }

    .right_list_wrap {
        flex: 1;
        max-width: calc(100% - 196px);
        height: 100%;
        background-color: #ffffff;
        padding: 16px;
        &.right_list_wrap_statistics {
            background-color: rgba(237, 240, 244, 1);
            padding: 4px;
            overflow-y: auto;
        }
    }
    .work_order_status {
        position: relative;
        padding-left: 10px;
        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -3px;
            width: 6px;
            height: 6px;
            opacity: 1;
            border-radius: 50%;
        }
        &.work_order_status0,
        &.work_order_status1,
        &.work_order_status2,
        &.work_order_status3,
        &.work_order_status4 {
            &::before {
                background-color: rgba(240, 170, 50, 1);
            }
        }
        &.work_order_status-1 {
            &::before {
                background-color: rgba(228, 65, 68, 1);
            }
        }
        &.work_order_status-2,
        &.work_order_status-3,
        &.work_order_status7 {
            &::before {
                background-color: rgba(191, 191, 191, 1);
            }
        }
        &.work_order_status5,
        &.work_order_status6 {
            &::before {
                background-color: rgba(90, 179, 51, 1);
            }
        }
    }
}
// .work_order_contact_field_wrap {
//     position: relative;
//     margin-left: -6px;
//     transition: all 0.3s ease;
//     width: 22px;
//     height: 22px;
//     // overflow: hidden;
//     &:first-child {
//         margin-left: 0;
//     }
//     .user_detail_popover {
//         position: absolute;
//         top: 0;
//         left: 0;
//     }
//     .work_user_info_wrap {
//         transition: transform 0.3s ease;
//         position: absolute;
//         left: 0;
//         top: 0;
//         .name {
//             opacity: 0;
//             font-size: 0;
//             margin-left: 0;
//             transition: all 0.3s ease;
//         }
//     }
//     &:hover {
//         .work_user_info_wrap {
//             .name {
//                 opacity: 1;
//                 font-size: 14px;
//                 margin-left: 8px;
//             }
//         }
//     }
// }
// .user-avatar-btn {
//     min-width: 22px;
//     max-width: 22px;
//     span {
//         padding: 0 !important;
//     }
// }
</style>
